import type { CSSProperties } from "react"

type TeamPickTone = "default" | "selected" | "winner" | "eliminated"

const FALLBACK_TEAM_COLOR = "#FFB020"

function normalizeHexColor(color?: string | null) {
  if (!color) return null
  const value = color.trim()
  const hexMatch = value.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i)
  if (!hexMatch) return null

  const hex = hexMatch[1]
  if (hex.length === 3) {
    return `#${hex.split("").map((char) => `${char}${char}`).join("")}`.toUpperCase()
  }
  return `#${hex}`.toUpperCase()
}

function hexToRgba(color: string, alpha: number) {
  const normalized = normalizeHexColor(color) ?? FALLBACK_TEAM_COLOR
  const hex = normalized.slice(1)
  const red = Number.parseInt(hex.slice(0, 2), 16)
  const green = Number.parseInt(hex.slice(2, 4), 16)
  const blue = Number.parseInt(hex.slice(4, 6), 16)
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`
}

function rowStyle(background: string, railColor: string, borderColor = "rgba(255, 255, 255, 0.08)"): CSSProperties {
  return {
    background,
    borderColor,
    borderLeftColor: railColor,
    borderLeftWidth: 3,
  }
}

export function getTeamPickAccentColor(color?: string | null) {
  return normalizeHexColor(color) ?? FALLBACK_TEAM_COLOR
}

export function getTeamPickCardStyle(color?: string | null, tone: TeamPickTone = "default"): CSSProperties {
  const accent = getTeamPickAccentColor(color)

  if (tone === "winner") {
    return rowStyle("rgba(0, 255, 102, 0.12)", "rgba(0, 255, 102, 0.48)")
  }

  if (tone === "eliminated") {
    return rowStyle("rgba(255, 43, 43, 0.085)", "rgba(255, 43, 43, 0.48)")
  }

  if (tone === "selected") {
    return rowStyle(hexToRgba(accent, 0.14), hexToRgba(accent, 0.72))
  }

  return rowStyle("rgba(11, 15, 20, 0.48)", hexToRgba(accent, 0.52))
}

export function getWorldCupGroupStagePickCardStyle(isSelected: boolean): CSSProperties {
  if (isSelected) {
    return rowStyle("rgba(255, 176, 32, 0.12)", "rgba(255, 176, 32, 0.54)", "rgba(255, 176, 32, 0.54)")
  }

  return rowStyle("rgba(11, 15, 20, 0.48)", "rgba(255, 176, 32, 0.42)")
}

export function getTeamPickRailStyle(color?: string | null): CSSProperties {
  return {
    backgroundColor: getTeamPickAccentColor(color),
  }
}
